import React, { useCallback } from 'react';
import DataTable from 'react-data-table-component';
import { Progress } from 'reactstrap';
import { Image } from '../../AbstractElements';

const TicketTable = ({ setSelectedRows, data, supportColumns, toggleDelet }) => {
  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const updatedData = data.map((item) => ({
    ...item,
    image: (
      <div className='d-flex'>
        <Image className='rounded-circle img-30 me-3' src={require(`../../assets/images/${item.image}`)} alt={item.name} />
        <div className='align-self-center'>
          <div>{item.name}</div>
        </div>
      </div>
    ),
    skill: (
      <div style={{ minWidth: '86px' }} className='progress-showcase'>
        <Progress style={{ height: '5px' }} value={item.skill} color={item.color} />
      </div>
    ),
  }));

  return <DataTable columns={supportColumns} data={updatedData} striped={true} center={true} pagination selectableRows onSelectedRowsChange={handleRowSelected} clearSelectedRows={toggleDelet} />;
};

export default TicketTable;
